import type {AddOfferTemplateNoteFormPayload} from "./add-offer-template-note.schema";
import {addOfferTemplateNote} from "@project/sdk/sales";
import {AddOfferTemplateNoteResponse} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";
import {offerTemplateKeys, offerTemplateMutationKeys} from "../../../../../offerTemplate-keys";
import {addOfferTemplateNoteFormSchema} from "./add-offer-template-note.schema";

export function addOfferTemplateNoteMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: offerTemplateMutationKeys.addOfferTemplateNote,
    mutationFn: async (payload: AddOfferTemplateNoteFormPayload) =>
      AddOfferTemplateNoteResponse.parse(
        await addOfferTemplateNote(id, addOfferTemplateNoteFormSchema.parse(payload)),
      ),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: offerTemplateKeys.detail(id)}),
        client.invalidateQueries({queryKey: offerTemplateKeys.lists()}),
      ]);
    },
  });
}
